import supabase from "../../../../supabaseClient.js";

interface church {
  body: string;
  churchName: string;
  user: string;
}

export class AxiosWidgetChurch {
  dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  async uploadProfileImage(
    file: string,
    filePath: string
  ): Promise<number | null> {
    const blob = this.dataURLtoBlob(file);
    var bucketName = "tanyapendeta bucket";
    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);
      console.log("what".concat(filePath));
      console.log(exists);
      if (exists) {
        const { error: removeError, data: hi } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);

        if (removeError) {
          console.error("Error deleting existing file:", removeError);
          return null;
        } else {
          const { data, error } = await supabase.storage
            .from(bucketName)
            .upload(filePath, blob, { cacheControl: "3600", upsert: false });

          if (error) {
            console.error("Error uploading image:", error);
            return null;
          }

          return 200;
        }
      } else {
        const { data, error } = await supabase.storage
          .from(bucketName)
          .upload(filePath, blob, { cacheControl: "3600", upsert: false });

        if (error) {
          console.error("Error uploading image:", error);
          return null;
        }

        return 200;
      }
    } catch (err) {
      console.error("An unexpected error occurred:", err);
      return null;
    }
  }

  public async getChurch(user: string) {
    const { data, error } = await (supabase as any)
      .from("church")
      .select("*")
      .eq("personCreate", user);

    if (error) {
      console.error("Error fetching question:", error.message);
      return { error: error.message };
    }

    return { data };
  }

  async uploadChurchImage(
    file: string,
    churchName: string,
    personCreate: string,
    fileName: string
  ): Promise<{ success?: boolean; imageUrl?: string; error?: string }> {
    const blob = this.dataURLtoBlob(file);
    var bucketName = "tanyapendeta bucket";

    // Create file path with _church suffix

    const filePath = `church_images/${fileName}`;

    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);

      console.log("Checking if file exists:", filePath);
      console.log("File exists:", exists);

      if (exists) {
        const { error: removeError } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);

        if (removeError) {
          console.error("Error deleting existing file:", removeError);
          return { error: removeError.message };
        }
      }

      const { data, error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, blob, { cacheControl: "3600", upsert: true });

      if (error) {
        console.error("Error uploading church image:", error);
        return { error: error.message };
      }

      // Return the public URL
      const {
        data: { publicUrl },
      } = supabase.storage.from(bucketName).getPublicUrl(filePath);

      return { success: true, imageUrl: publicUrl };
    } catch (err) {
      console.error("An unexpected error occurred:", err);
      return { error: "An unexpected error occurred" };
    }
  }

  async uploadChurchLogo(
    file: string,
    churchName: string,
    personCreate: string,
    fileName: string
  ): Promise<{ success?: boolean; imageUrl?: string; error?: string }> {
    const blob = this.dataURLtoBlob(file);
    const bucketName = "tanyapendeta bucket";
    const filePath = `church_logos/${fileName}`;

    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);

      if (exists) {
        const { error: removeError } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);
        if (removeError) {
          console.error("Error deleting existing logo:", removeError);
          return { error: removeError.message };
        }
      }

      const { error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, blob, { cacheControl: "3600", upsert: true });

      if (error) {
        console.error("Error uploading church logo:", error);
        return { error: error.message };
      }

      const {
        data: { publicUrl },
      } = supabase.storage.from(bucketName).getPublicUrl(filePath);

      return { success: true, imageUrl: publicUrl };
    } catch (err) {
      console.error("An unexpected error occurred (logo):", err);
      return { error: "An unexpected error occurred" };
    }
  }

  public async createChurch(question: {
    name: string;
    introduction: string;
    personCreate: string;
    fileName: string; // main image file name
    logoFileName?: string; // optional logo file name
  }) {
    // Attempt insert with optional logoName; if it fails due to column issue, retry without logoName
    const basePayload: any = {
      name: question.name,
      introduction: question.introduction,
      personCreate: question.personCreate,
      imagesName: question.fileName,
    };

    if (question.logoFileName) {
      basePayload.logoName = question.logoFileName;
    }

    let { data, error } = await (supabase as any)
      .from("church")
      .insert(basePayload);

    if (error && question.logoFileName) {
      console.warn(
        "Insert with logoName failed, retrying without logoName:",
        error.message
      );
      const retryPayload = { ...basePayload };
      delete (retryPayload as any).logoName;
      const retry = await (supabase as any).from("church").insert(retryPayload);
      data = retry.data;
      error = retry.error;
    }

    if (error) {
      console.error("Error creating church:", error.message);
      return { error: error.message };
    }

    return { data };
  }

  public async updateChurchByName(
    name: string,
    introduction: string,
    fileName: string | null
  ) {
    const updatePayload: any = { introduction };
    if (fileName) updatePayload.imagesName = fileName;

    const { data, error } = await (supabase as any)
      .from("church")
      .update(updatePayload)
      .eq("name", name);

    if (error) {
      console.error("Error updating church:", error.message);
      return { error: error.message };
    }
    return { data };
  }

  public async updateQuestion(question: { id: number; question: string }) {
    const { data, error } = await (supabase as any)
      .from("ProfileQuestion")
      .update({
        body: question.question,
      })
      .eq("id", question.id);

    if (error) {
      console.error("Error updating question:", error.message);

      throw error;
    }

    return data;
  }
}

export default new AxiosWidgetChurch();
